import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import CssBaseline from '@mui/material/CssBaseline';
import Button from '@mui/material/Button';
import { InputBase, Select, MenuItem } from '@mui/material';
import { Search } from '@mui/icons-material';
import DrawerComponent from './DrawerComponent';
import { NttLogo } from '../../assets/images/ntt-logo-header.js';
import { SELECTION_ITEMS } from '../../assets/data/dummyData';
import "./Header.css";

const Header = () => {
	const [selectedValue, setSelectedValue] = useState("Categories");
	const [mobileOpen, setMobileOpen] = useState(false);

	const handleDrawerToggle = () => {
		setMobileOpen((prevState) => !prevState);
	};

	const handleSelectionChange = (e) => {
		setSelectedValue(e.target.value)
	};

	return (
		<Box className="w-full items-center">
			<CssBaseline />
			<AppBar position="static" className="items-center justify-start">
				<Toolbar className="bg-white w-full lg:gap-x-64 md:gap-x-32 gap-x-0 header-toolbar">
					<div className="flex items-center justify-between pr-4 lg:pl-16">
						<div className="logo flex">
							<NttLogo />
						</div>
						<div className="lg:hidden md:hidden drawer-component">
							<DrawerComponent
								handleDrawerToggle={handleDrawerToggle}
								mobileOpen={mobileOpen}
							/>
						</div>
					</div>
					<div className="flex w-full search-btns">
						<InputBase
							className="header-search-input lg:w-7/12 lg:h-12 h-8 md:w-7/12 w-11/12"
							placeholder="Search…"
							inputProps={{ "aria-label": "search" }}
						/>
						<div className="lg:block md:block sm:block hidden">
							<Select
								value={selectedValue}
								onChange={handleSelectionChange}
								className="lg:w-40 md:w-32 lg:h-12 h-8"
								renderValue={(selected) => {
									if (!selectedValue) {
										return <span>Placeholder</span>;
									}
									return selected
								}}
								placeholder="Categories"
								inputProps={{
									MenuProps: {
										MenuListProps: {
											sx: {
												backgroundColor: "#00254F",
												color: "white",
											}
										}
									}
								}
								}
								style={{ backgroundColor: "#F4F5F6" }}
								sx={{
									"& .MuiListItem-button:focus": {
										backgroundColor: "red"
									},
									"& .MuiListItem-button:hover": {
										backgroundColor: "initial"
									}
								}}
							>
								{SELECTION_ITEMS.map((item) =>
									<MenuItem className="select-item" key={item.id} value={item.name}>{item.name}</MenuItem>
								)}
							</Select>
						</div>

						<div className="lg:pl-2 md:pl-2 pl-0">
							<Button variant="contained" className="search-btn lg:w-24 md:w-12 lg:h-12 w-8 h-8" style={{ backgroundColor: "#0059BC" }}><Search /></Button>
						</div>
					</div>
				</Toolbar>
			</AppBar>
		</Box>
	);

};

export default Header;